import { useContext, useLayoutEffect, useRef, useState } from "react";
import { BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './Diversity.css';
import { LocaleContext } from "../common/App";
import { Footer } from "./WebsiteCommon";

export function Diversity(props) {
    const locale = useContext(LocaleContext);

    return (
        <div>
            <img className="img_width" src="/customer/04_header_diversity.jpg"></img>
            <div className="text_box margin_bottom_high">
                <div className="text_small">{locale.msgs.DIVERSITY}</div>

                <div className="text_big_big margin_top_middle">{locale.msgs.ALL_FOR_ALL_EXTENDED}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.ALL_FOR_ALL_DESCR_EXTENDED}}></div>
            </div>

            <Footer />
        </div>
    );
}
